import request from '@/utils/request';

export function getAgencyJobs(params) {
  return request({
    url: '/admin/agency-jobs',
    method: 'get',
    params,
  });
}

export function approveAgencyJob(id, data = {}) {
  return request({
    url: `/admin/agency-jobs/${id}/approve`,
    method: 'patch',
    data,
  });
}

export function rejectAgencyJob(id, data = {}) {
  return request({
    url: `/admin/agency-jobs/${id}/reject`,
    method: 'patch',
    data,
  });
}

export function deleteAgencyJob(id) {
  return request({
    url: `/admin/agency-jobs/${id}`,
    method: 'delete',
  });
}
